import axios from 'axios'
import { store } from '../index'
import moment from 'moment'

export default {
  async FETCH_CLASSES ({ commit }) {
    try{
      let classes = await axios.get('/api/classes', { headers: { 'Authorization': `Bearer ${store.getters.GET_TOKEN}` }})
      commit('SET_CLASS_DATA', classes.data)
    } catch(e) {
      console.log(e)
    }
  },
  async FETCH_POSTS({ commit }, { class_id }) {
    try{
      let posts = await axios.get(`/api/posts`, { 
        headers: { 
          'Authorization': `Bearer ${store.getters.GET_TOKEN}` 
        },
        params: {
          class_id
        }
      })
      let postsData = posts.data.map(post => {
        post.created_at = moment(post.created_at).fromNow()
        post.updated_at = moment(post.updated_at).fromNow()
        post.comments.map(comment => {
          comment.created_at = moment(comment.created_at).fromNow()
          comment.updated_at = moment(comment.updated_at).fromNow()
          return comment
        })
        return post
      })
      commit('SET_POSTS', postsData)
    }catch(e){
      console.log(e)
    }
  },
  async FETCH_FILES({ commit }, { class_id }) {
    try{
      let files = await axios.get(`/api/class/files/${class_id}`, { headers: { 'Authorization': `Bearer ${store.getters.GET_TOKEN}` }})
      commit('SET_FILES', files.data)
    }catch(e){
      console.log(e)
    }
  },
  async FETCH_ASSIGNMENTS({ commit }, { class_id }) {
    try{
      let files = await axios.get(`/api/class/files/assignments/${class_id}`, { headers: { 'Authorization': `Bearer ${store.getters.GET_TOKEN}` }})
      console.log(files)
      // commit('SET_FILES', files.data)
    }catch(e){
      console.log(e)
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/Student/actions.js